<div
  class="loader d-flex flex-column align-items-center justify-content-center"
>
  <img
    src="https://media.umangapp.in/cdn/landing/icons/fetch.png"
    alt="fetching-data"
    loading="lazy"
    fetchpriority="high"
    
  />
  {{ message | translate }}...
</div>
